import React from 'react';
import HeroSlider from './HeroSlider';
import ProductTabs from './ProductTabs';
import Banner from './Banner';
import BlogPosts from './BlogPosts';
import Testimonials from './Testimonials';
import IconBoxes from './IconBoxes';
import { FeaturedCollections, ImageText, CustomHtml, VideoSection, NewsletterSection } from './Misc';

const MAP = {
  hero_slider: HeroSlider,
  product_tabs: ProductTabs,
  banner: Banner,
  blog_posts: BlogPosts,
  testimonials: Testimonials,
  icon_boxes: IconBoxes,
  featured_collections: FeaturedCollections,
  image_text: ImageText,
  custom_html: CustomHtml,
  video: VideoSection,
  newsletter: NewsletterSection,
};

// Renders the ordered homepage section list produced by /api/settings/home.
export default function SectionRenderer({ sections = [] }) {
  return (
    <>
      {sections.map((s) => {
        const Cmp = MAP[s.type];
        if (!Cmp) return null;
        return (
          <div key={s.id} id={`section-${s.id}`} className="shopify-section">
            <Cmp section={s} />
          </div>
        );
      })}
    </>
  );
}
